<template>
  <v-card flat class="listCard">
    <v-card-title>
      <span class="cardTitle ml-3">{{ cardTitle }}</span>
    </v-card-title>
    <v-card-text>
      <v-select
        v-model="selectValue"
        class="select"
        height="24"
        :items="selectOptions"
        :value="selectValue"
        dense
        solo
        flat
      >
        <template slot="item" slot-scope="data">
          <span class="itemText">{{ data.item }}</span>
        </template>
      </v-select>
      <ItemListCaption />
      <ItemList
        v-for="item in orderedListItems"
        :key="item.name"
        :name="item.name"
        :count="item.count"
      />
    </v-card-text>
  </v-card>
</template>

<script>
import ItemList from "@/components/atoms/Procedimento/item-list";
import ItemListCaption from "@/components/atoms/Procedimento/item-list-caption";

export default {
  components: {
    ItemList,
    ItemListCaption
  },
  data() {
    return {
      selectOptions: ["Mais recorrentes", "Menos recorrentes"],
      selectValue: "Mais recorrentes"
    };
  },
  computed: {
    orderedListItems() {
      if (this.selectValue === "Mais recorrentes")
        return this.listItems.slice(0).sort((a, b) => b.count - a.count);
      else return this.listItems.slice(0).sort((a, b) => a.count - b.count);
    }
  },
  props: {
    cardTitle: {
      type: String,
      required: true
    },
    listItems: {
      type: [Array, Object],
      required: true
    }
  }
};
</script>

<style scoped>
.listCard {
  background: #ffffff;
  border-radius: 10px;
  width: 349px;
  height: 396px;
}

.cardTitle {
  font-family: "Montserrat", sans-serif;
  font-weight: 500;
  font-size: 14px;
  line-height: 24px;
  letter-spacing: 0.16px;
  font-feature-settings: "pnum" on, "lnum" on;
  color: #212121;
}

.select {
  width: 190px;
  font-family: "Montserrat", sans-serif;
  font-size: 12px;
  line-height: 20px;
  letter-spacing: 0.32px;
  font-feature-settings: "pnum" on, "lnum" on;
  color: #424242;
  margin-bottom: -30px;
}

.itemText {
  font-family: "Montserrat", sans-serif;
  font-size: 12px;
  line-height: 20px;
  letter-spacing: 0.32px;
  font-feature-settings: "pnum" on, "lnum" on;
  color: #424242;
}
</style>